import React, { useState, useEffect } from "react";
import { Card, Typography, Switch, Divider, Spin, Alert, Button, message } from "antd";
import { BellOutlined, MailOutlined, SyncOutlined, CheckCircleOutlined } from "@ant-design/icons";
import {
  getNotificationPreferences,
  updateNotificationPreferences
} from "../../services/notificationService";

const { Title, Text } = Typography;

const NotificationPreferencesPage = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [preferences, setPreferences] = useState({
    emailEnabled: true,
    orderStatusChange: true,
    orderAssignment: true,
    dailyDigest: false
  });

  const userType = localStorage.getItem("userType");

  useEffect(() => {
    fetchPreferences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPreferences = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getNotificationPreferences(userType);
      setPreferences(response.data);
    } catch (err) {
      console.error("Error fetching preferences:", err);
      // Use defaults if no preferences exist
      setPreferences({
        userType: userType,
        emailEnabled: true,
        orderStatusChange: true,
        orderAssignment: true,
        dailyDigest: false
      });
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (field) => {
    setPreferences(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateNotificationPreferences({
        ...preferences,
        userType: userType
      });
      message.success("Bildirim tercihleri kaydedildi");
    } catch (err) {
      console.error("Error saving preferences:", err);
      message.error("Tercihler kaydedilemedi");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <Title level={2}>
        <BellOutlined style={{ marginRight: 12 }} />
        Bildirim Tercihleri
      </Title>
      <Text type="secondary">
        E-posta bildirimlerinizi ve tercihlerinizi yönetin
      </Text>

      {error && (
        <Alert
          message="Hata"
          description={error}
          type="error"
          showIcon
          style={{ marginTop: 16, marginBottom: 16 }}
        />
      )}

      <Card style={{ marginTop: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <Title level={4} style={{ margin: 0 }}>
              <MailOutlined style={{ marginRight: 8 }} />
              E-posta Bildirimleri
            </Title>
            <Text type="secondary">Tüm e-posta bildirimlerini aç/kapat</Text>
          </div>
          <Switch
            checked={preferences.emailEnabled}
            onChange={() => handleToggle('emailEnabled')}
            checkedChildren="Açık"
            unCheckedChildren="Kapalı"
          />
        </div>

        <Divider />

        <div style={{ opacity: preferences.emailEnabled ? 1 : 0.5, pointerEvents: preferences.emailEnabled ? 'auto' : 'none' }}>
          <Title level={5}>Bildirim Türleri</Title>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
            <div>
              <Text strong>Sipariş Durumu Değişiklikleri</Text>
              <br />
              <Text type="secondary">Siparişlerinizin durumu değiştiğinde bildirim alın</Text>
            </div>
            <Switch
              checked={preferences.orderStatusChange}
              onChange={() => handleToggle('orderStatusChange')}
              disabled={!preferences.emailEnabled}
            />
          </div>

          <Divider style={{ margin: '8px 0' }} />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
            <div>
              <Text strong>Görev Atamaları</Text>
              <br />
              <Text type="secondary">Size yeni bir görev atandığında bildirim alın</Text>
            </div>
            <Switch
              checked={preferences.orderAssignment}
              onChange={() => handleToggle('orderAssignment')}
              disabled={!preferences.emailEnabled}
            />
          </div>

          <Divider style={{ margin: '8px 0' }} />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0' }}>
            <div>
              <Text strong>Günlük Özet</Text>
              <br />
              <Text type="secondary">Her gün aktivitelerinizin özetini e-posta ile alın</Text>
            </div>
            <Switch
              checked={preferences.dailyDigest}
              onChange={() => handleToggle('dailyDigest')}
              disabled={!preferences.emailEnabled}
            />
          </div>
        </div>

        <Divider />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <Button
            icon={<SyncOutlined />}
            onClick={fetchPreferences}
            disabled={saving}
          >
            Sıfırla
          </Button>
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={handleSave}
            loading={saving}
          >
            Kaydet
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default NotificationPreferencesPage;
